import { mergeStyles } from '@cian/components';
import * as React from 'react';
import { getScrollTop } from '../../utils/scroll';
import { LogoPIK } from '../logo_pik/logo_pik';
import { Menu } from '../menu/menu';
import { Phone } from '../phone/phone';
import { RecallButton } from '../recall_button/recall_button';
import { Socials } from '../socials/socials';

const styles = require('./sidebar.css');

const HEADER_HEIGHT = 110;

interface IState {
  contentIsFixed: boolean;
  fixingTopOffset: number;
}

export class Sidebar extends React.PureComponent<object, IState> {
  public state: IState = {
    contentIsFixed: false,
    fixingTopOffset: 0,
  };

  private sidebar: HTMLElement;

  public componentDidMount() {
    this.updateContentIsFixed();
    window.addEventListener('scroll', this.updateContentIsFixed);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.updateContentIsFixed);
  }

  public render() {
    const { contentIsFixed } = this.state;

    const contentStyles = mergeStyles(styles['content'], contentIsFixed && styles['content-fixed']);

    return (
      <aside className={styles['container']} ref={this.setFixingTopOffset}>
        <div {...contentStyles}>
          <div className={styles['logo-container']}>
            <LogoPIK />
          </div>
          <div className={styles['menu-container']}>
            <Menu />
          </div>
          <div className={styles['phone-container']}>
            <Phone />
          </div>
          <div className={styles['socials-container']}>
            <Socials />
          </div>
          <div className={styles['recall-container']}>
            <RecallButton />
          </div>
        </div>
      </aside>
    );
  }

  private setFixingTopOffset = (el: HTMLElement) => {
    if (!el) {
      return;
    }

    let fixingTopOffset = el.getBoundingClientRect().top;
    this.sidebar = el;

    // если скролл уже есть при загрузке страницы, то ставим дефолтный отступ
    // т.к. не можем наверняка узнать высоту шапки через getBoundingClientRect
    if (getScrollTop() > 0) {
      fixingTopOffset = HEADER_HEIGHT;
    }

    this.setState({ fixingTopOffset });
  };

  private updateContentIsFixed = () =>
    requestAnimationFrame(() => {
      if (!window) {
        return;
      }

      const scrollTop = getScrollTop();
      const sidebarOffsetTop = this.sidebar.getBoundingClientRect().top;
      const shouldBeFixed = scrollTop > this.state.fixingTopOffset;

      let newState = {};

      if (shouldBeFixed !== this.state.contentIsFixed) {
        newState = { contentIsFixed: shouldBeFixed };
      }

      // если вдруг высота шапки поменяется
      if (scrollTop === 0 && this.state.fixingTopOffset !== sidebarOffsetTop) {
        newState = {
          ...newState,
          fixingTopOffset: sidebarOffsetTop,
        };
      }

      this.setState(newState);
    });
}
